import React from 'react';

const Frame = () => {
    return (
        <div id="Frame">
            <div className="frame_line frame_line-left"></div>
            <div className="frame_line frame_line-right"></div>
            <div className="frame_line frame_line-top"></div>
            <div className="frame_line frame_line-bottom"></div>
        </div>
    );
}

export default Frame;

